module.exports = __webpack_public_path__ + "img/cover.6918d2a0.webp";